import { AxiosResponse } from 'axios';
import { csrfToken, getCsrfToken, instance, getCsrfTokenOnCookie } from '../db';
import {
  MemberGetType,
  MemberRegisterInfoType
} from '../../validation/user/userType';
import { withdrawReasonEnum } from '../../constants/Enum';

// メンバー取得API
export const getMemberList = async (): Promise<{
  data: MemberGetType;
}> => {
  await getCsrfToken();

  const response = await instance.get('/members', {
    headers: {
      'X-XSRF-TOKEN': csrfToken
    }
  });
  return response;
};

// 事務局が企業を指定してメンバー取得する
export const getMemberListByCompanyId = async (
  companyId: number
): Promise<{
  data: MemberGetType;
}> => {
  await getCsrfToken();

  const response = await instance.get(`/members?company_id=${companyId}`, {
    headers: {
      'X-XSRF-TOKEN': csrfToken
    }
  });
  return response;
};

// 認証メール送信API
export const sendMailForResisterMembers = async (
  email: string
): Promise<AxiosResponse> => {
  const csrftoken = await getCsrfTokenOnCookie();

  return await instance.post(
    '/members/email',
    { email: email },
    {
      headers: {
        'X-XSRF-TOKEN': csrftoken
      }
    }
  );
};

// 権限更新APIの呼び出し
export const updateMemberRoleLeader = async (
  userId: number | null | undefined
): Promise<AxiosResponse> => {
  const csrftoken = await getCsrfTokenOnCookie();

  return await instance.post(`/members/${userId}`, {
    headers: {
      'X-XSRF-TOKEN': csrftoken
    }
  });
};

// メール認証API
export const verifyMemberEmail = async (confirmationToken: string | null) => {
  return await instance.get(
    '/users/email_verification?token=' + confirmationToken
  );
};

// 会員情報登録API
export const registerMemberInfo = async (
  id: string,
  email: string,
  token: string,
  watch: (fieldName: string) => MemberRegisterInfoType
): Promise<AxiosResponse> => {
  const csrftoken = await getCsrfTokenOnCookie();

  return await instance.put(
    '/members/register',
    {
      id,
      email,
      token,
      last_name: watch('lastName'),
      first_name: watch('firstName'),
      last_name_kana: watch('lastNameKana'),
      first_name_kana: watch('firstNameKana'),
      password: watch('password')
    },
    {
      headers: {
        'X-XSRF-TOKEN': csrftoken
      }
    }
  );
};

// メンバー削除API
export const memberWithdraw = async (
  memberId: number | null,
  isInvited: boolean = false
): Promise<AxiosResponse> => {
  return await instance.delete(`/users`, {
    data: {
      reason: isInvited
        ? withdrawReasonEnum.deletedInvitationByLeader
        : withdrawReasonEnum.deletedByLeader,
      member_id: memberId
    },
    headers: { 'X-XSRF-TOKEN': csrfToken }
  });
};
